class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.search_form = document.querySelector("#global__predictive_search");
    this.mobile_search_container = document.querySelector(
      "#global__mobile_predictive_search"
    );

    this.btn_openForm = document.querySelector("#open_search_form");
    this.btn_closeForm = document.querySelector("#close_search_form");
    this.mobile_search_icon = document.querySelector("#mobile_search");

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector("#predictive-search");

    this.insert_form();

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    this.btn_openForm.addEventListener("click", () => this.show_search_form());
    this.btn_closeForm.addEventListener("click", () => this.hide_search_form());

    this.mobile_search_icon.addEventListener(
      "click",
      this.swicth_search_form.bind(this)
    );
  }

  swicth_search_form(event) {
    //1. Get button
    const button = event.target.closest("#mobile_search");
    if (!button) return;

    if (this.search_form.getAttribute("is-active") === "true") {
      if (window.innerWidth > 980) {
        this.hide_search_form();
      } else {
        window.scrollTo(0, 0);
        document.getElementById("Search").focus();
        document.getElementById("Search").select();
      }
      return;
    }

    if (this.search_form.getAttribute("is-active") === "false") {
      this.show_search_form();
      document.getElementById("Search").focus();
      document.getElementById("Search").select();
      return;
    }
  }

  show_search_form() {
    this.search_form.setAttribute("is-active", "true");
    if (window.innerWidth > 980) {
      document.getElementById("Search").focus();
      document.getElementById("Search").select();
    }
  }

  hide_search_form() {
    this.search_form.setAttribute("is-active", "false");
  }

  insert_form() {
    const section = document.querySelector("#global__predictive_search");

    if (window.innerWidth <= 980) {
      this.mobile_search_container.appendChild(section);
      if (
        document.body.classList.contains("index") ||
        document.body.classList.contains("collection")
      ) {
        this.show_search_form();

        // FIXME:  Inteligems Test ID
        if (
          sessionStorage.getItem("ig-variation") ==
          "2a7d6254-6f0b-4f6f-92e4-a30be64aec6d"
        ) {
          this.initObserver();
        }
      }
      return;
    }

    if (window.innerWidth > 980) {
      document.querySelector(".seeks").appendChild(section);
      this.hide_search_form();
      return;
    }
  }

  initObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.mobile_search_container.classList.remove("fix-search-bar");
        } else {
          this.mobile_search_container.classList.add("fix-search-bar");
        }
      },
      {
        threshold: 1,
        rootMargin: "-25px 0px 0px 0px",
      }
    );
    observer.observe(document.querySelector("body"));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(
      `/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = "block";
  }

  close() {
    this.predictiveSearchResults.style.display = "none";
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("predictive-search", PredictiveSearch);

var crossBtn = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<path d="M5.33366 15.8333L4.16699 14.6667L8.83366 9.99999L4.16699 5.33332L5.33366 4.16666L10.0003 8.83332L14.667 4.16666L15.8337 5.33332L11.167 9.99999L15.8337 14.6667L14.667 15.8333L10.0003 11.1667L5.33366 15.8333Z" fill="#3D3D3D"/>
</svg>
`;

document.body.addEventListener("click", (e) => {
  var { target } = e;
  if (target.closest(`.crossBtn`)) {
    e.preventDefault();
    var inputElement = document.querySelector("predictive-search input#Search");
    var searchResults = document.querySelector("#predictive-search");
    searchResults.style.display = "none";
    inputElement.value = "";
    inputElement.focus();
  }
});

var searchElement = document.querySelector("predictive-search");
var inputElement = searchElement.querySelector("input#Search");
var controlCloseElement = searchElement.querySelector("#close_search_form");
//inputElement.setAttribute('placeholder', 'Search for Dresses, Rompers, Skirts...');
if (!document.querySelector(`.crossBtn`)) {
  controlCloseElement.insertAdjacentHTML(
    "afterbegin",
    `<div class="crossBtn">${crossBtn}</div>`
  );
}

if (window.matchMedia("(max-width: 980px)").matches) {
  function setupSearchHandlers() {
    const searchInput = document.querySelector("input#Search");
    const closeBtn = document.querySelector("#close_search_form");
    const searchIcon = document.querySelector(".mobile_icon_search");
    const searchForm = document.querySelector("predictive-search form");
    const searchWrapper = document.querySelector(
      "#global__predictive_search predictive-search"
    );

    if (!searchInput || !closeBtn || !searchIcon || !searchForm) {
      // Retry in 100ms until all elements are found
      setTimeout(setupSearchHandlers, 100);
      return;
    }

    // Hide close button by default
    searchInput.setAttribute("placeholder", "Search Sozy");
    closeBtn.style.opacity = "0";
    searchWrapper.style.borderColor = "#E0E0E0";

    // Show on focus
    searchInput.addEventListener("focus", () => {
      closeBtn.style.opacity = "0.4";
      searchWrapper.style.borderColor = "#3c3c3c";
    });

    // Hide on blur
    searchInput.addEventListener("blur", () => {
      setTimeout(() => {
        closeBtn.style.opacity = "0";
        searchWrapper.style.borderColor = "#E0E0E0";
      }, 100);
    });

    // Submit form on click or touch of search icon
    const submitSearch = () => {
      searchForm.submit();
    };

    searchIcon.addEventListener("click", submitSearch);
    searchIcon.addEventListener("touchstart", submitSearch);
  }

  // Start
  setupSearchHandlers();
}
